/* Release countdown in the opening field (snippets/hero-drop.liquid). The cached page can be minutes
   old, so the browser clock decides: at the release time the timer gives way to the on-sale line and
   the cards get their hrefs. */
(() => {
  'use strict';
  const pad = (value) => String(value).padStart(2, '0');
  const initialize = (root) => {
    if (root.dataset.dropBound) return;
    root.dataset.dropBound = 'true';
    const target = Date.parse(root.dataset.dropTarget || '');
    if (Number.isNaN(target)) return;
    const number = (unit) => root.querySelector(`[data-drop-num="${unit}"]`);
    const numbers = { d: number('d'), h: number('h'), m: number('m'), s: number('s') };
    const dayParts = root.querySelectorAll('[data-drop-day]');
    let timer = 0;
    const goLive = () => {
      window.clearTimeout(timer);
      root.classList.add('is-live');
      root.querySelectorAll('[data-drop-before]').forEach((node) => { node.hidden = true; });
      root.querySelectorAll('[data-drop-after]').forEach((node) => { node.hidden = false; });
      root.querySelectorAll('[data-drop-href]').forEach((link) => { link.setAttribute('href', link.dataset.dropHref); });
    };
    const tick = () => {
      window.clearTimeout(timer);
      const left = target - Date.now();
      if (left <= 0) { goLive(); return; }
      const total = Math.ceil(left / 1000);
      const days = Math.floor(total / 86400);
      dayParts.forEach((node) => { node.hidden = days === 0; });
      if (numbers.d) numbers.d.textContent = String(days);
      if (numbers.h) numbers.h.textContent = pad(Math.floor((total % 86400) / 3600));
      if (numbers.m) numbers.m.textContent = pad(Math.floor((total % 3600) / 60));
      if (numbers.s) numbers.s.textContent = pad(total % 60);
      // Wake on the next whole second of the time left.
      timer = window.setTimeout(tick, (left % 1000) || 1000);
    };
    tick();
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && !root.classList.contains('is-live')) tick();
    });
  };
  const initializeAll = (scope = document) => {
    if (scope.matches?.('[data-drop-hero]')) initialize(scope);
    scope.querySelectorAll('[data-drop-hero]').forEach(initialize);
  };
  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
